import classes from './TextOverflow.module.scss'
import type {
  CSSProperties,
  ReactNode
} from 'react'

export interface Props {
  children: ReactNode
  lines: number
}

/**
 * A React component that truncates its children text after a specified number of lines,
 * applying an ellipsis to indicate overflow. Uses CSS line clamping for multi-line truncation.
 *
 * @param children - The content to be displayed and potentially truncated.
 * @param lines - The maximum number of lines to display before truncating.
 */
const TextOverflow = ({
  children,
  lines
}: Props) => {
  const wrapper: CSSProperties = {
    WebkitLineClamp: `${lines}`
  }

  return (
    <span
      className={classes.TextOverflow}
      style={wrapper}
    >
      {children}
    </span>
  )
}

export default TextOverflow
